import React from 'react';
import { graphql, StaticQuery, Link } from "gatsby";
import { StaticImage } from 'gatsby-plugin-image';
import footerLogo1 from '../../images/footer-logo-new-1.svg';
import footerLogo2 from '../../images/footer-logo-new-2.svg';
import footerLogo4 from '../../images/footer-logo-new-4.svg';
import '../../sass/components/_components.footer.scss';
import twitter from '../../images/icon-twitter-white.svg';
import linkedin from '../../images/icon-linkedin-white.svg';
import facebook from '../../images/icon-facebook-white.svg';
import instagram from '../../images/icon-instagram-white.svg';
import planfulLogo from '../../images/planful-logo-latest-svg.svg';

const Footerebook = () => {
    return (
        <footer className="cp-footer l--ebook">
            <div className="cp-footer__inner">
                <div className="cp-footer__top l--flex">
                    <StaticQuery query={graphql`
{
    allWordpressMenuItem(filter: {menu: {node: {name: {eq: "Footer Menu"}}}}) {
      edges {
        node {
          label
          url
          cssClasses
          parentId
          target
          childItems {
            nodes {
              label
              url
              cssClasses
              childItems {
                nodes {
                  label
                  url
                  cssClasses
                  target
                }
              }
              target
            }
          }
        }
      }
    }
  }                           
                `} render={props => (
                            <>
                                <div className="cp-footer__top-left">
                                    <Link to={`/`}>
                                        <img loading="lazy" src={planfulLogo} alt="Planful" />
                                    </Link>
                                </div>
                                <div className="cp-footer__top-right">
                                    <div className="cp-footer__top-rightBottom l--flex">
                                        <div className="l-ebookLinks l--flex">
                                            <a href="https://trust.planful.com/" target="_blank" rel="noreferrer">Trust &amp; Security</a>
                                            <a href="/terms-of-use/">Terms</a>
                                            <a href="/privacy-policy/">Privacy</a>
                                            <a href="/cookie-policy/">Cookies</a>
                                            <a href="https://healthy.kaiserpermanente.org/front-door/machine-readable" target="_blank" rel="noreferrer">Group Plan</a>
                                            <span className="cp-footer__bottom-copyright">© {new Date().getFullYear()} Planful. All rights reserved.</span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )} />
                </div>
            </div>
        </footer>
    )
};

export default Footerebook;